module.exports = __webpack_public_path__ + "static/media/icon-pentagon.18344646.svg";